// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlackSquareOutlinedSvg from "@fishx/icons-svg/es/asn/SlackSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var SlackSquareOutlined = function SlackSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlackSquareOutlinedSvg
  }));
};

SlackSquareOutlined.displayName = 'SlackSquareOutlined';
export default React.forwardRef(SlackSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SlackSquareOutlined.js
// module id = 4148
// module chunks = 0